export var SecurityRestrictionReason = /*#__PURE__*/ function(SecurityRestrictionReason) {
    SecurityRestrictionReason["DRM"] = "DRM";
    SecurityRestrictionReason["HDCP"] = "HDCP";
    return SecurityRestrictionReason;
}({});
export var ContentType = /*#__PURE__*/ function(ContentType) {
    ContentType["text"] = "text/plain";
    ContentType["textXml"] = "text/xml";
    ContentType["application"] = "application/x-www-form-urlencoded";
    ContentType["applicationStream"] = "application/octet-stream";
    return ContentType;
}({});

//# sourceMappingURL=drm.enums.js.map